export default __webpack_public_path__ + "static/media/three.bf0bc8f8.jpg";